import type { AppVueRouter } from '@modules/core/services/router/types';
import type { TranslationKeysMapper } from '@modules/i18n/types';
import { AppModule } from '@modules/core/plugins/AppModule';
import { ADMIN_PLAYERS_BONUSES_CREATE_ROUTE_NAME } from '@modules/players-bonuses/submodules/create/constants';
import {
  PLAYERS_BONUS_CREATE_FILE_ROUTE_NAME,
  TRANSLATION_PLAYER_BONUS_CREATE_FILE,
} from '@modules/players-bonuses/submodules/create/submodules/file-bonus-create/constants';
import { getTranslationKeys } from '@modules/players-bonuses/submodules/create/submodules/file-bonus-create/translations';

export class FileBonusCreateModule extends AppModule {
  addRoutes(router: AppVueRouter): void {
    router.addChildRoute(ADMIN_PLAYERS_BONUSES_CREATE_ROUTE_NAME, {
      name: PLAYERS_BONUS_CREATE_FILE_ROUTE_NAME,
      path: 'file',
      component: () => import('@modules/players-bonuses/submodules/create/submodules/file-bonus-create/pages/FileBonusCreate/FileBonusCreate.vue'),
    });
  }

  addMenu(): void {}

  addTranslationKeys(mapper: TranslationKeysMapper): void {
    mapper.addTranslationsMap(TRANSLATION_PLAYER_BONUS_CREATE_FILE, getTranslationKeys);
  }
}
